import { useControllableState as e } from "@radix-ui/react-use-controllable-state";
import { useCallbackRef as o } from "@radix-ui/react-use-callback-ref";
import { Primitive as r } from "@radix-ui/react-primitive";
import { useId as t } from "@radix-ui/react-id";
import { createContextScope as n } from "@radix-ui/react-context";
import { useComposedRefs as i } from "@radix-ui/react-compose-refs";
import { createCollection as c } from "@radix-ui/react-collection";
import { composeEventHandlers as u } from "@radix-ui/primitive";
import * as s from "react";
import a from "@babel/runtime/helpers/esm/extends";
const f = {
    bubbles: !1,
    cancelable: !0
  },
  [p, l, m] = c("RovingFocusGroup"),
  [d, v] = n("RovingFocusGroup", [m]);
export { v as createRovingFocusGroupScope };
const [g, F] = d("RovingFocusGroup");
export const RovingFocusGroup = /*#__PURE__*/s.forwardRef((e, o) => /*#__PURE__*/s.createElement(p.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /*#__PURE__*/s.createElement(p.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /*#__PURE__*/s.createElement(w, a({}, e, {
  ref: o
}))))); /*#__PURE__*/
const w = /*#__PURE__*/s.forwardRef((t, n) => {
  const {
      __scopeRovingFocusGroup: c,
      orientation: p,
      dir: m = "ltr",
      loop: d = !1,
      currentTabStopId: v,
      defaultCurrentTabStopId: F,
      onCurrentTabStopIdChange: w,
      onEntryFocus: b,
      ...x
    } = t,
    E = s.useRef(null),
    I = i(n, E),
    [G = null, h] = e({
      prop: v,
      defaultProp: F,
      onChange: w
    }),
    [T, A] = s.useState(!1),
    y = o(b),
    D = l(c),
    S = s.useRef(!1);
  return s.useEffect(() => {
    const e = E.current;
    if (e) return e.addEventListener("rovingFocusGroup.onEntryFocus", y), () => e.removeEventListener("rovingFocusGroup.onEntryFocus", y);
  }, [y]), /*#__PURE__*/s.createElement(g, {
    scope: c,
    orientation: p,
    dir: m,
    loop: d,
    currentTabStopId: G,
    onItemFocus: s.useCallback(e => h(e), [h]),
    onItemShiftTab: s.useCallback(() => A(!0), [])
  }, /*#__PURE__*/s.createElement(r.div, a({
    tabIndex: T ? -1 : 0,
    "data-orientation": p
  }, x, {
    ref: I,
    style: {
      outline: "none",
      ...t.style
    },
    onMouseDown: u(t.onMouseDown, () => {
      S.current = !0;
    }),
    onFocus: u(t.onFocus, e => {
      const o = !S.current;
      if (e.target === e.currentTarget && o && !T) {
        const o = new Event("rovingFocusGroup.onEntryFocus", f);
        if (e.currentTarget.dispatchEvent(o), !o.defaultPrevented) {
          const e = D().filter(e => e.focusable);
          R([e.find(e => e.active), e.find(e => e.id === G), ...e].filter(Boolean).map(e => e.ref.current));
        }
      }
      S.current = !1;
    }),
    onBlur: u(t.onBlur, () => A(!1))
  })));
});
export const RovingFocusGroupItem = /*#__PURE__*/s.forwardRef((e, o) => {
  const {
      __scopeRovingFocusGroup: n,
      focusable: i = !0,
      active: c = !1,
      ...f
    } = e,
    m = t(),
    d = F("RovingFocusGroupItem", n),
    v = d.currentTabStopId === m,
    g = l(n); /*#__PURE__*/
  return s.createElement(p.ItemSlot, {
    scope: n,
    id: m,
    focusable: i,
    active: c
  }, /*#__PURE__*/s.createElement(r.span, a({
    tabIndex: v ? 0 : -1,
    "data-orientation": d.orientation
  }, f, {
    ref: o,
    onMouseDown: u(e.onMouseDown, e => {
      i ? d.onItemFocus(m) : e.preventDefault();
    }),
    onFocus: u(e.onFocus, () => d.onItemFocus(m)),
    onKeyDown: u(e.onKeyDown, e => {
      if ("Tab" === e.key && e.shiftKey) return void d.onItemShiftTab();
      if (e.target !== e.currentTarget) return;
      const o = function (e, o, r) {
        const t = function (e, o) {
          return "rtl" !== o ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
        }(e.key, r);
        return "vertical" === o && ["ArrowLeft", "ArrowRight"].includes(t) || "horizontal" === o && ["ArrowUp", "ArrowDown"].includes(t) ? void 0 : b[t];
      }(e, d.orientation, d.dir);
      if (void 0 !== o) {
        e.preventDefault();
        let n = g().filter(e => e.focusable).map(e => e.ref.current);
        if ("last" === o) n.reverse();else if ("prev" === o || "next" === o) {
          "prev" === o && n.reverse();
          const i = n.indexOf(e.currentTarget);
          n = d.loop ? (t = i + 1, (r = n).map((e, o) => r[(t + o) % r.length])) : n.slice(i + 1);
        }
        setTimeout(() => R(n));
      }
      var r, t;
    })
  })));
}); /*#__PURE__*/
const b = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function R(e) {
  const o = document.activeElement;
  for (const r of e) {
    if (r === o) return;
    if (r.focus(), document.activeElement !== o) return;
  }
}
export const Root = RovingFocusGroup;
export const Item = RovingFocusGroupItem;